import icon from '../../assets/icons/yellow-star.png'

const CommentCard = ({name,text,date,score}) => {
    return(
        <div
        className='p-1 flex flex-col gap-2'
        >
            <div
            className='flex justify-between'
            >
                <p
                className='flex gap-1'
                >
                    <span
                    className='text-[#444444] opacity-80'
                    >
                    {name}
                    </span>
                <span
                className='text-[#929292]'
                >
                    {date}
                </span>
                </p>
                <p
                className='flex gap-1'
                >
                    <span
                    className='text-[#F4C542]'
                    >
                        {score}
                    </span>
                    <img
                    src={icon}
                    className='w-3 object-contain'
                    />
                </p>
            </div>
             <p
                className='text-justify'
                >
                    {text}
                </p>
        </div>
    )
}
export default CommentCard